export default "__VITE_ASSET__DaFAq5Ji__"